export default __webpack_public_path__ + "static/media/graphQuery.db94de5f.svg";